var ResultsPager = React.createClass({
  propTypes: {
    pagerDetail: React.PropTypes.object.isRequired,
    onPageClicked: React.PropTypes.func.isRequired
  },
  pageClicked(num) {
    this.props.onPageClicked(num);
  },
  getNextPage() {
    let nextPage = this.props.pagerDetail.currentPage + 1;
    return <li>{this.getLink(nextPage, <span className="fa fa-chevron-right"></span>)}</li>;
  },
  getPreviousPage() {
    let prevPage = this.props.pagerDetail.currentPage - 1;
    return <li>{this.getLink(prevPage, <span className="fa fa-chevron-left"></span>)}</li>;
  },
  getFirstPage() {
    return <li>{this.getLink(1, <span className="fa fa-fast-backward"></span>)}</li>;
  },
  getItem(num) {
    let isCurrentPage = num == this.props.pagerDetail.currentPage;
    let pageItem = isCurrentPage ?
      <span>{num}</span> : this.getLink(num);

    return (
      <li key={num} className={isCurrentPage ? "active" : ""}>
        {pageItem}
      </li>
    )
  },
  getLink(num, innerItem = num) {
    return <a href="#" onClick={this.pageClicked.bind(this, num)}>{innerItem}</a>;
  },
  render() {
    let { pagerDetail } = this.props;

    if (pagerDetail.totalPages == 0) {
      return <span />
    }

    let pageLinks = pagerDetail.pageNumbers.map(this.getItem);

    return (
      <nav className="text-center">
        <ul className="pagination">
          {pagerDetail.previousDisplayed ? this.getPreviousPage() : null}
          {pageLinks}
          {pagerDetail.nextDisplayed ? this.getNextPage() : null}
        </ul>
      </nav>
    )
  }
});